module.exports = __webpack_public_path__ + "static/media/choithramsAppStore.298ba8bd.png";